<div appObserveVisibility (visible)="loadComponent()"></div>

<div class="card card--progress h-full">
  <div class="card-header">
    <svg-icon src="assets/images/svg-icons/progress/icon-nb_q.svg"></svg-icon>
    <span i18n> Statistiques training </span>

    <span class="nb_questions" *ngIf="trainingStatistics">
      <strong>{{ trainingStatistics.totalAnsweredQuestions }}</strong
      >/{{ trainingStatistics.totalPublishedOnTrainingQuestions }}
    </span>
  </div>
  <div class="card-content graph_questions flex items-center justify-start space-x-8">
    <ng-container *ngIf="trainingStatistics">
      <ng-container *ngIf="trainingStatistics.totalAnsweredQuestions">
        <div class="shrink-0 relative w-36 h-36">
          <div class="absolute top-0 bottom-0 right-0 left-0">
            <div id="svg_questionsPartiallyCorrect"></div>
          </div>
          <div class="absolute top-0 bottom-0 right-0 left-0">
            <div id="svg_questionsCorrect"></div>
          </div>
        </div>
        <div class="questions_stats ml-4">
          <div class="stat_label">
            {{ 'progress.correctes' | translate }}
            ({{ trainingStatistics.totalCorrectlyAnsweredQuestions }})
          </div>
          <div class="stat_color -green"></div>
          <div class="stat_value">
            {{
              (trainingStatistics.totalCorrectlyAnsweredQuestions /
                trainingStatistics.totalAnsweredQuestions) *
                100 | number : '1.0-0' : 'fr'
            }}%
          </div>
          <ng-container *ngIf="trainingStatistics.totalPartiallyCorrectlyAnsweredQuestions > 0">
            <div class="stat_label">
              {{ 'progress.p_corrected' | translate }}
              ({{ trainingStatistics.totalPartiallyCorrectlyAnsweredQuestions }})
            </div>
            <div class="stat_color -yellow"></div>
            <div class="stat_value">
              {{
                (trainingStatistics.totalPartiallyCorrectlyAnsweredQuestions /
                  trainingStatistics.totalAnsweredQuestions) *
                  100 | number : '1.0-0' : 'fr'
              }}%
            </div>
          </ng-container>
          <div class="stat_label">
            {{ 'progress.fausses' | translate }}
            ({{ trainingStatistics.totalWronglyAnsweredQuestions }})
          </div>
          <div class="stat_color -red"></div>
          <div class="stat_value">
            {{
              (trainingStatistics.totalWronglyAnsweredQuestions /
                trainingStatistics.totalAnsweredQuestions) *
                100 | number : '1.0-0' : 'fr'
            }}%
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="trainingStatistics.totalAnsweredQuestions === 0"
        class="font-bold w-full text-center"
      >
        {{ 'ancrage.pas_donnees' | translate }}
      </div>
    </ng-container>

    <div class="spinner_element_container" *ngIf="!trainingStatistics">
      <app-loader-dots></app-loader-dots>
    </div>
  </div>
</div>
